import { measurements, colors } from 'app/theme'
import css from 'styled-jsx/css'

export default css`
  .full-width {
    width: 100%;
  }
  .panel {
    border-radius: ${measurements.borderRadius};
    background-color: ${colors.white};
    border: solid 1px ${colors.border};
    padding: 1.5rem 2rem;
    margin: 1rem 0;
    display: flex;
    flex-direction: column;
  }
  .header {
    border-bottom: solid 1px ${colors.border};
  }
`
